import styled from "styled-components";
import { Flex } from "@chakra-ui/react";

export const ListViewContainer = styled(Flex)`
  @media print {
    & {
      width: 680px !important;
      gap: 0px !important;
      padding: 0 !important;
      display: block !important;

      .center-container {
        float: left;
        display: block !important;
        gap: 0px !important;
        * {
          line-height: 16px;
        }
      }

      .right-container {
        float: right;
        display: block !important;
      }
    }
  }
`;
